(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brine-home"] && !Shopify.designMode) return;
  try {
    
class PicklesHoodieHero extends HTMLElement {
  connectedCallback() { this.startFrame = requestAnimationFrame(() => this.setup()); }
  disconnectedCallback() { cancelAnimationFrame(this.startFrame); cancelAnimationFrame(this.frame); this.abort?.abort(); this.motionQuery?.removeEventListener('change', this.motionChange); this.querySelector('[data-audio]')?.pause(); }
  setup() {
    this.abort?.abort(); this.abort = new AbortController(); const signal = this.abort.signal;
    this.hero = this.querySelector('.hs-hero'); if (!this.hero) return;
    this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)'); this.paused = this.dataset.motion === 'off'; this.motionChange = () => this.queueMotion(); this.motionQuery.addEventListener('change', this.motionChange);
    this.querySelector('[data-motion-toggle]')?.addEventListener('click', () => { this.paused = !this.paused; this.updateMotionControl(); this.queueMotion(); }, { signal });
    window.addEventListener('scroll', () => this.queueMotion(), { passive: true, signal }); window.addEventListener('resize', () => this.queueMotion(), { passive: true, signal });
    const dialog = this.querySelector('[data-audio-dialog]'), audio = this.querySelector('[data-audio]'), listen = this.querySelector('[data-listen]'), status = this.querySelector('[data-audio-status]');
    listen?.addEventListener('click', () => { if (dialog && !dialog.open) dialog.showModal(); if (audio?.paused) { if (status) status.textContent = ''; audio.play().catch(() => { if (status) status.textContent = this.dataset.audioBlocked || ''; }); } }, { signal });
    this.querySelector('[data-dialog-close]')?.addEventListener('click', () => dialog?.close(), { signal });
    dialog?.addEventListener('close', () => listen?.focus({ preventScroll: true }), { signal });
    dialog?.addEventListener('click', (event) => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } }, { signal });
    const syncAudio = () => { const label = listen?.querySelector('[data-listen-label]'); if (label) label.textContent = audio.paused ? this.dataset.playLabel : this.dataset.playingLabel; };
    for (const event of ['play', 'pause', 'ended']) audio?.addEventListener(event, syncAudio, { signal });
    audio?.addEventListener('error', () => { if (status) status.textContent = this.dataset.audioError || ''; }, { signal });
    this.updateMotionControl(); this.queueMotion();
  }
  updateMotionControl() { const b = this.querySelector('[data-motion-toggle]'); if (!b) return; b.setAttribute('aria-pressed', String(this.paused)); b.setAttribute('aria-label', this.paused ? this.dataset.resumeLabel : this.dataset.pauseLabel); const text = b.querySelector('[data-motion-label]'); if (text) text.textContent = this.paused ? this.dataset.resumeText : this.dataset.pauseText; }
  queueMotion() { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.drawMotion(); }); }
  drawMotion() { const r = this.hero.getBoundingClientRect(), off = this.paused || this.motionQuery.matches; let p = off ? 0 : Math.min(Math.max(-r.top, 0), r.height); if (window.innerWidth < 600) p *= .3; const values = { '--hs-room-y': `${p * .17}px`, '--hs-room-scale': String(1.04 + p * .00008), '--hs-title-y': `${p * .13}px`, '--hs-left-x': `${-p * .05}px`, '--hs-left-y': `${-p * .075}px`, '--hs-right-x': `${p * .06}px`, '--hs-right-y': `${-p * .13}px`, '--hs-center-y': `${-p * .22}px` }; for (const [key, value] of Object.entries(values)) this.hero.style.setProperty(key, value); }
}
if (!customElements.get('pickles-hoodie-hero')) customElements.define('pickles-hoodie-hero', PicklesHoodieHero);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-brine-product"]) return;
  try {
    
if(!customElements.get('brine-scroll-gallery')){
customElements.define('brine-scroll-gallery',class extends HTMLElement{
connectedCallback(){
this.controller=new AbortController();
const signal=this.controller.signal;
const track=this.querySelector('.brine-gallery-track'),slides=[...this.querySelectorAll('.brine-gallery-slide')],prev=this.querySelector('[data-gallery-prev]'),next=this.querySelector('[data-gallery-next]'),count=this.querySelector('[data-gallery-count]'),thumbnails=[...this.querySelectorAll('[data-gallery-thumbnail]')],thumbnailTrack=this.querySelector('.brine-gallery-thumbnails');
if(!slides.length)return;
let index=Math.max(0,slides.findIndex(s=>s.dataset.imageId===this.dataset.selected));
let targetIndex=null,lastWidth=track.clientWidth;
const current=()=>Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/Math.max(1,track.clientWidth))));
const sync=()=>{
const visibleIndex=current();
if(targetIndex===null)index=visibleIndex;
if(count)count.textContent=String(visibleIndex+1);
if(prev)prev.disabled=visibleIndex===0;
if(next)next.disabled=visibleIndex===slides.length-1;
thumbnails.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===visibleIndex)));
const thumbnail=thumbnails[visibleIndex];
if(thumbnail&&thumbnailTrack){
const frame=thumbnailTrack.getBoundingClientRect(),item=thumbnail.getBoundingClientRect();
if(item.left<frame.left+12)thumbnailTrack.scrollLeft-=frame.left+12-item.left;
else if(item.right>frame.right-12)thumbnailTrack.scrollLeft+=item.right-frame.right+12;
}
};
const go=(i,animate=true)=>{index=Math.max(0,Math.min(slides.length-1,i));targetIndex=index;const smooth=animate&&!matchMedia('(prefers-reduced-motion: reduce)').matches;track.scrollTo({left:index*track.clientWidth,behavior:smooth?'smooth':'instant'});if(!smooth){targetIndex=null;sync();}};
thumbnails.forEach((button,i)=>button.addEventListener('click',()=>go(i),{signal}));
prev?.addEventListener('click',()=>go(current()-1),{signal});
next?.addEventListener('click',()=>go(current()+1),{signal});
track.addEventListener('scroll',sync,{passive:true,signal});
track.addEventListener('scrollend',()=>{targetIndex=null;sync();},{signal});
track.addEventListener('pointerdown',()=>{targetIndex=null;},{passive:true,signal});
track.addEventListener('wheel',()=>{targetIndex=null;},{passive:true,signal});
track.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();go(e.key==='Home'?0:e.key==='End'?slides.length-1:current()+(e.key==='ArrowRight'?1:-1));},{signal});
const select=this.closest('[data-brine-product]').querySelector('[data-product-variant]');
select?.addEventListener('change',()=>{const i=slides.findIndex(s=>s.dataset.imageId===select.selectedOptions[0]?.dataset.imageId);if(i>=0)go(i,false);},{signal});
this.observer=new ResizeObserver(()=>{if(track.clientWidth!==lastWidth){lastWidth=track.clientWidth;go(targetIndex??index,false);}});this.observer.observe(track);go(index,false);
}
disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pickles-play"] && !Shopify.designMode) return;
  try {
    
  if(!window.picklesFullscreenBound){
    window.picklesFullscreenBound=true;
    function expand(section,active){
      section.classList.toggle('is-expanded',active);
      section.querySelector('[data-pickles-close]').hidden=!active;
      if(active){section.dataset.previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';section.querySelector('[data-pickles-close]').focus();}
      else{document.body.style.overflow=section.dataset.previousOverflow||'';section.querySelector('[data-pickles-fullscreen]').focus();}
    }
    document.addEventListener('click',function(event){
      const close=event.target.closest('[data-pickles-close]');
      if(close){expand(close.closest('[data-pickles-play]'),false);return;}
      const button=event.target.closest('[data-pickles-fullscreen]');
      if(!button)return;
      const section=button.closest('[data-pickles-play]');
      const frame=section.querySelector('iframe');
      if(!frame)return;
      const fallback=()=>expand(section,true);
      if(frame.requestFullscreen){frame.requestFullscreen().catch(fallback);}else{fallback();}
    });
    document.addEventListener('keydown',event=>{if(event.key==='Escape'){const section=document.querySelector('[data-pickles-play].is-expanded');if(section)expand(section,false);}});
    function initialize(){if(new URLSearchParams(window.location.search).get('expanded')==='1'){const section=document.querySelector('[data-pickles-play]');if(section)expand(section,true);}}
    if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initialize,{once:true});}else{initialize();}
  }

  } catch(e) { console.error(e); }
})();
})();
